<template>
 
  <el-dialog
    title="添加分类"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose" :append-to-body="true">
    <el-form size="small" :model="form" ref="form" label-width="100px" class="demo-ruleForm">
      <el-form-item label="所属上级" :label-width="formLabelWidth">
        <el-select v-model="form.pid">
          <el-option label="顶级分类" value="0"></el-option>
          <el-option :value="cat.group_id" :label="cat.group_name" :key="cat.group_id" v-for="cat in typeList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="分类名称"
        prop="categoryname"
        :rules="[
          { required: true, message: '名字不能为空'}
        ]"
      >
        <el-input type="age" v-model="form.categoryname" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort" >
        <el-input type="age" v-model="form.sort" autocomplete="off"></el-input>
        <div class="gray">数字越大越靠后</div>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm('form')"  :loading="loading">提交</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>
</template>

<script>
import FileApi from '@/api/file.js';
export default {
  data(){
    return {
      /*是否显示*/
      dialogVisible:true,
      /*from表单模型*/
      form:{
        categoryname:'',
        pid:0,
        sort:'100',
      },
      typeList:[],
      /*分类名称*/
      categoryName:'',
      loading:false,
    }
  },
  props:['category'],
  created() {
    console.log(this.category);
    if(this.category!=null){
      this.form.categoryname=this.category.group_name;
      this.form.group_id=this.category.group_id
      this.form.pid=this.category.pid
    }
    this.getFileCategory();
  },
  methods:{
    /*获取图片类别*/
      getFileCategory() {
        let self = this;
        let param = {}
        FileApi.fileCategory({
          is_top:1
        }, true)
          .then(res => {
            self.typeList = res.data.group_list;
          })
          .catch(error => {
            self.loading = false;
          });
      },
    /*添加图片类别*/
    addCategory: function(model) {
      let self = this;
      self.loading = true;
      let param={
        group_name: model.categoryname,
        group_id:model.group_id,
        pid:model.pid,
        sort:model.sort,
      };
      FileApi.addCategory(param,).then(data => {
          self.$message({
            message: '添加成功',
            type: 'success'
          });
          self.loading = false;
          self.handleClose({status:'success'});
        })
        .catch(error => {
          self.loading = false;
          self.$message.error('添加失败');
        });
    },

    /*修改图片类别*/
    editCategory: function(model) {
      let self = this;
      let param={
        group_name: model.categoryname,
        group_id:model.group_id,
        pid:model.pid,
        sort:model.sort,
      };
      console.log(param);
      FileApi.editCategory(param,).then(data => {
          self.$message({
            message: '修改成功',
            type: 'success'
          });
          self.handleClose({status:'success'});
        })
        .catch(error => {
          self.$message.error('修改失败');
        });
    },

    /*提交*/
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.category&&this.category.group_id!=null){
            this.editCategory(this.form);
          }else{
            this.addCategory(this.form);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },


    /*关闭弹窗*/
    handleClose(param){
      this.dialogVisible=false;
      this.$emit('closeCategory',param);
    }
  }

}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/file/part/AddCategory.vue